import { render, staticRenderFns } from "./RelatedDestinationItem.vue?vue&type=template&id=165d3960&"
import script from "./RelatedDestinationItem.vue?vue&type=script&lang=ts&"
export * from "./RelatedDestinationItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports